import type { ActionIconProps } from '@mantine/core';
import { ActionIcon } from '@mantine/core';

import { faMessages } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface FloatingChatButtonProps extends ActionIconProps {
  onClick?: () => void;
}

export function FloatingChatButton(props: FloatingChatButtonProps) {
  return (
    <ActionIcon
      variant="filled"
      radius="xl"
      w="4.25rem"
      h="4.25rem"
      mt="md"
      {...props}
    >
      <FontAwesomeIcon icon={faMessages} size="xl" />
    </ActionIcon>
  );
}
